import { Checkbox, FormControl, HStack, Text } from '@chakra-ui/react';

const InputCheckbox = ({ fieldName, fieldValue, isRequired, onChange, showRequiredStar = false, ...props }) => {
  return (
    <FormControl>
      <Checkbox
        type="checkbox"
        id={fieldName}
        name={fieldName}
        required={isRequired}
        defaultChecked={fieldValue}
        onChange={e => onChange(fieldName, e.target.checked)}
        size={{ base: 'lg', md: 'md' }}
      >
        <HStack gap="2px">
          {showRequiredStar && isRequired && (
            <Text color="red.500" fontSize="xs">
              *
            </Text>
          )}
          {props.children}
        </HStack>
      </Checkbox>
    </FormControl>
  );
};

export default InputCheckbox;
